export default __webpack_public_path__ + "static/media/Boton_5.e3a1b400.png";